import React from 'react';
import { PhoneCall, ClipboardList, Wrench, ThumbsUp, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    icon: PhoneCall,
    title: 'Call or Book Online',
    desc: 'Call 0418 381 988 or submit our quick form. For emergencies, we respond as fast as possible.'
  }, {
    icon: ClipboardList,
    title: 'Upfront Quote — No Surprises',
    desc: 'We assess the job and give you a clear, fixed price before any work begins. No hidden extras.'
  }, {
    icon: Wrench,
    title: 'Expert Service, Same Day',
    desc: 'Our licensed electricians arrive on time, work safely, and complete most standard jobs same-day.'
  }, {
    icon: ThumbsUp,
    title: 'Your Complete Satisfaction',
    desc: "We test everything, clean up, and don't leave until you're 100% happy. That's the Completely Electrical Guarantee."
  }];
  return <section className="py-20 lg:py-28 bg-white" data-id="element-378">
      <div className="max-w-7xl mx-auto px-4" data-id="element-379">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-380">
          <span className="text-orange font-bold tracking-wider uppercase text-sm mb-3 block" data-id="element-381">
            Simple Process
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-6 tracking-tighter" data-id="element-382">
            How It Works
          </h2>
          <p className="text-lg text-slate leading-relaxed" data-id="element-383">
            Getting your electrical issues sorted shouldn't be complicated.
            Here's how simple it is to work with us.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-384">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[12%] right-[12%] h-1 bg-gradient-to-r from-orange/20 via-orange to-orange/20 z-0 rounded-full overflow-hidden bg-[length:200%_100%] animate-shimmer" data-id="element-385"></div>

          <div className="grid md:grid-cols-4 gap-12 relative z-10" data-id="element-386">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="text-center relative group" data-id="element-387">
                <div className="w-24 h-24 mx-auto bg-white border-4 border-cream rounded-full flex items-center justify-center mb-8 relative z-10 group-hover:border-orange transition-colors shadow-lg" data-id="element-388">
                  <div className="absolute -top-4 -right-4 w-10 h-10 bg-orange rounded-full flex items-center justify-center font-extrabold text-white text-lg shadow-md border-2 border-white" data-id="element-389">
                    {index + 1}
                  </div>
                  <step.icon className="w-10 h-10 text-navy group-hover:text-orange transition-colors" data-id="element-390" />
                </div>

                <h3 className="text-lg font-heading font-extrabold text-navy mb-3" data-id="element-391">
                  {step.title}
                </h3>
                <p className="text-slate text-sm leading-relaxed" data-id="element-392">
                  {step.desc}
                </p>

                {index < steps.length - 1 && <div className="md:hidden flex justify-center mt-8" data-id="element-393">
                    <div className="w-px h-12 bg-gradient-to-b from-orange to-transparent" data-id="element-394"></div>
                  </div>}
              </motion.div>)}
          </div>
        </div>

        {/* Micro-CTA */}
        <div className="text-center mt-14" data-id="element-395">
          <p className="text-slate font-bold mb-4" data-id="element-396">
            Most jobs quoted promptly and completed same-day.
          </p>
          <a href="#quote" className="inline-flex items-center gap-2 bg-orange hover:bg-orange-600 text-white px-8 py-4 rounded-xl font-extrabold text-lg transition-all shadow-lg hover:-translate-y-1" data-id="element-397">
            Start With a Free Quote
            <ArrowRight className="w-5 h-5" data-id="element-398" />
          </a>
        </div>
      </div>
    </section>;
}